import { MPA_TRANSACTIONS_EDIT_REQUEST, MPA_TRANSACTIONS_EDIT_SUCCESS, MPA_TRANSACTIONS_EDIT_FAILURE } from './types/ManualPreadviceTransactionsEditActionTypes';

export function putManualPreadviceTransactionsEditRequestActionCreator(context,
  newComments,
  newDepartureDateTime,
  newImpcFrom,
  newImpcTo,
  newOperatorFrom,
  newOperatorTo,
  newPlannedArrivalDateTime,
  newQuantity,
  newTransactionId) {
  return {
    type: MPA_TRANSACTIONS_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: newComments,
        departureDateTime: newDepartureDateTime,
        impcFrom: newImpcFrom,
        impcTo: newImpcTo,
        operatorFrom: newOperatorFrom,
        operatorTo: newOperatorTo,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function putManualPreadviceTransactionsEditSuccessActionCreator(data) {
  return {
    type: MPA_TRANSACTIONS_EDIT_SUCCESS,
    payload: data,
  };
}

export function putManualPreadviceTransactionsEditFailureActionCreator(error) {
  return {
    type: MPA_TRANSACTIONS_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
